export enum CommentStatus {
    UNKNOWN,
    DELETED,
    LIVE
}